import { Theme } from '@mui/material';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import QuillTextBox from 'components/Quill/QuillTextBox';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

const styles = (theme: Theme) => createStyles({
    charsLeft: {
        fontSize: theme.typography.body1.fontSize,
        color: theme.palette.grey[500]
    },
});

interface IState {
}

interface IProps {
    autoFocus?: boolean;
    className?: string;
    height?: number;
    htmlContent?: string;
    id?: string;
    maxLength: number;
    placeholder?: string;
    readOnly?: boolean;
    textContent?: string;
    theme?: "snow" | "bubble";

    onChange?: (htmlContent: string, textContent: string) => void;
    onFocus?: () => void;
}

type Props = IProps & WithTranslation  & WithStyles<typeof styles>;

class QuillTextFieldCounter extends React.PureComponent<Props, IState> {

    static defaultProps = {
        className: "ql-transparent",
        readonly: false,
        autoFocus: false
    }

    private handleChangeContent = (content: string, delta: any, source: any, editor: any) => {

        if (this.props.onChange)
            this.props.onChange(content, editor.getText().trim());
    }

    render() {
        return (
            <>
                <QuillTextBox
                    key={this.props.id}
                    autoFocus={this.props.autoFocus}
                    className={this.props.className}
                    height={this.props.height}
                    theme={this.props.theme}
                    content={this.props.htmlContent}
                    readOnly={this.props.readOnly}
                    onChange={this.handleChangeContent}
                    onFocus={this.props.onFocus}
                    placeholder={this.props.placeholder}
                />
                {
                    this.props.textContent != null &&
                    (this.props.textContent.length > 0 && this.props.maxLength - this.props.textContent.length >= 0)  &&
                    <div className={this.props.classes.charsLeft}>
                        {this.props.maxLength - this.props.textContent.length} <span>{this.props.t("Common.Literals.CharsRemaining")}</span>
                    </div>
                }
                {
                    this.props.textContent != null &&
                    (this.props.maxLength - this.props.textContent.length < 0) &&
                    <div className={this.props.classes.charsLeft}>
                        <MuiColor variant="error">
                            {this.props.textContent.length - this.props.maxLength} <span>{this.props.t("Common.Literals.CharsAboveLimit")}</span>
                        </MuiColor >
                    </div>
                }
            </>
        );
    }
}

export default withStyles(styles)(withTranslation()(QuillTextFieldCounter));